import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_TERMS_AND_CONDITIONS_ERROR:
    'settings/digitalQuote/FETCH_TERMS_AND_CONDITIONS_ERROR',
  FETCH_TERMS_AND_CONDITIONS_SUCCESS:
    'settings/digitalQuote/FETCH_TERMS_AND_CONDITIONS_SUCCESS',

  UPDATE_TERMS_AND_CONDITIONS_ERROR:
    'settings/digitalQuote/UPDATE_TERMS_AND_CONDITIONS_ERROR',
  UPDATE_TERMS_AND_CONDITIONS_REQUEST:
    'settings/digitalQuote/UPDATE_TERMS_AND_CONDITIONS_REQUEST',
  UPDATE_TERMS_AND_CONDITIONS_SUCCESS:
    'settings/digitalQuote/UPDATE_TERMS_AND_CONDITIONS_SUCCESS',
};

export const fetchTermsAndConditions = {
  error: () => ({
    type: types.FETCH_TERMS_AND_CONDITIONS_ERROR,
  }),
  success: ({ termsAndConditions }) => ({
    type: types.FETCH_TERMS_AND_CONDITIONS_SUCCESS,
    payload: { termsAndConditions },
  }),
};

export const updateTermsAndConditions = {
  error: notify(
    (error) => ({
      type: types.UPDATE_TERMS_AND_CONDITIONS_ERROR,
      payload: error,
    }),
    "Can't update Terms and Conditions",
  ),
  request: ({ termsAndConditions }) => ({
    type: types.UPDATE_TERMS_AND_CONDITIONS_REQUEST,
    payload: { termsAndConditions },
  }),
  success: notify(
    ({ termsAndConditions }) => ({
      type: types.UPDATE_TERMS_AND_CONDITIONS_SUCCESS,
      payload: { termsAndConditions },
    }),
    'Success',
    'Terms and Conditions successfully updated',
  ),
};
